export default function CTASection() {
  const handleDownload = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-gradient-to-br from-[#F8F9FA] to-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="font-serif text-4xl font-bold text-[#0B1F3B] mb-6">
          Accedi alla Documentazione Completa
        </h2>
        <p className="text-lg text-[#1C1C1C]/70 mb-10 leading-relaxed">
          Scarica white paper, guide operative e template di perizia per comprendere la valutazione patrimoniale del brand secondo standard ISO difendibili.
        </p>
        <button
          onClick={handleDownload}
          className="inline-flex items-center gap-3 px-8 py-4 bg-[#0B1F3B] text-white text-base font-semibold rounded-md hover:bg-[#0B1F3B]/90 transition-all whitespace-nowrap cursor-pointer shadow-lg"
        >
          <i className="ri-download-2-line text-xl"></i>
          Scarica Documentazione Patrimoniale
        </button>
        <p className="text-sm text-[#1C1C1C]/60 mt-6">
          Materiali tecnici conformi a normative internazionali ISO 10668 e ISO 20671
        </p>
      </div>
    </section>
  );
}
